import React, { useEffect } from 'react';
import ChartsCard from '../chartsCard/chartsCard';
import { FunnelChart } from 'common';
import { useState } from 'react';
import {
  formatJobTalentStats,
  getJobTalentStats,
} from 'controllers/dashboard/getJobTalentStats';

const ApplicantsFunnel = ({ jobId }) => {
  const [chartData, setChartData] = useState([]);
  const [chartLabels, setChartLabels] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const response = await getJobTalentStats(jobId);
      const { labels, data } = formatJobTalentStats(response);
      setChartData(data);
      setChartLabels(labels);
    };

    fetchData();
  }, [jobId]);

  return (
    <ChartsCard title={'Applicants Funnel'} spaceRight={false}>
      <br />
      <FunnelChart data={chartData} chartLabels={chartLabels} />
    </ChartsCard>
  );
};

export default ApplicantsFunnel;
